import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ErrorWrapper, getErrorText } from '@trade-platform/ui-shared';
import {
    OrderBundleCandidatesLoad,
    OrderBundleCandidatesActionTypes,
    OrderBundleCandidatesLoadFailure,
    OrderBundleCandidatesLoadSuccess
} from './actions';
import { OrderBundleCandidatesService } from './service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class OrderBundleCandidatesEffects {
    private actions$ = inject(Actions);
    private orderBundleCandidatesService = inject(OrderBundleCandidatesService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderBundleCandidatesLoad$ = createEffect(() =>
        this.actions$.pipe(
            ofType<OrderBundleCandidatesLoad>(
                OrderBundleCandidatesActionTypes.ORDER_BUNDLE_CANDIDATES_LOAD
            ),
            switchMap(action =>
                this.orderBundleCandidatesService.getBundleCandidates(action.payload.orderId).pipe(
                    map(res => new OrderBundleCandidatesLoadSuccess(res)),
                    catchError((error: string | HttpErrorResponse) => {
                        const err =
                            error instanceof HttpErrorResponse
                                ? new ErrorWrapper(error.message, {
                                      status: error.status,
                                      errorText: getErrorText(error)
                                  })
                                : new ErrorWrapper(error);
                        return of(
                            new OrderBundleCandidatesLoadFailure({ error: err as ErrorWrapper })
                        );
                    })
                )
            )
        )
    );
}
